


















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AclMember } from "@/services/security/types";
import ChannelAccessModal from "@/components/channels/modals/ChannelAccessModal.vue";
import { channelAccessFields } from "@/components/channels/fields/channelAccessFields";

@Component({
    components: { ChannelAccessModal }
})
export default class ChannelAccess extends Vue {
    @Prop() acl!: AclMember[];

    // local state
    localAcl = [] as AclMember[];
    fields = channelAccessFields;
    searchQuery = ""

    mounted() {
        this.localAcl = this.acl;
    }

    @Watch("acl")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localAcl = this.acl;
    }

    // computed
    get filteredData() {
        return this.localAcl && this.localAcl
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.username.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    promptAddChannelAccess() {
        (this.$refs.channelAccessModal as any).open();
    }

    removeAccess(id: string) {
        const item = this.localAcl.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localAcl.splice(this.localAcl.indexOf(item), 1);
    }

    onAccessUpdated(data: AclMember[]) {
        this.localAcl = data;
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("accessUpdated", JSON.parse(JSON.stringify(this.localAcl)));
    }
}
